import {useState} from 'react';

import ALink from "../ALink";
import {categoryParam} from "../../../utils/slugs";

function CategoryFlyout({categories, onSelect}) {
    // Tracks which item at THIS level has its sub-list expanded (one open at a time).
    const [openId, setOpenId] = useState(null);

    if (!categories || categories.length === 0) {
        return null;
    }

    return (
        <div className="cat-menu__panel">
            {categories.map((category) => {
                const hasChildren = category.children && category.children.length > 0;
                const isOpen = openId === category.id;

                return (
                    <div
                        key={category.id}
                        className={`cat-menu__item${hasChildren ? ' has-children' : ''}${isOpen ? ' open' : ''}`}
                    >
                        <div className="cat-menu__row">
                            <ALink
                                href={`/shop?category=${categoryParam(category)}`}
                                className="cat-menu__link"
                                onClick={() => onSelect(category.id)}
                            >
                                {category.name}
                            </ALink>
                            {hasChildren ? (
                                <button
                                    type="button"
                                    className="cat-menu__arrow"
                                    aria-label={category.name}
                                    aria-expanded={isOpen}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setOpenId(isOpen ? null : category.id);
                                    }}
                                >
                                    <span className="cat-menu__caret"/>
                                </button>
                            ) : null}
                        </div>
                        {hasChildren && isOpen ? (
                            <div className="cat-menu__submenu">
                                <CategoryFlyout categories={category.children} onSelect={onSelect}/>
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}

export default CategoryFlyout;
